// extracted by mini-css-extract-plugin
export var border = "_2g-b";
export var circle = "_2g-3";
export var circleInner = "_2g-5";
export var disabled = "_2g-1";
export var focused = "_2g-a";
export var md = "_2g-8";
export var radioButton = "_2g-0";
export var radioInput = "_2g-2";
export var selected = "_2g-9";
export var sm = "_2g-7";
export var text = "_2g-4";
export var xs = "_2g-6";